import { BoxSlotItemEntity } from "@/modules/boxSlot/entities/boxSlotEntity"
import { type BoxSlotItemDto } from "@modules/boxSlot/gateway/boxSlotDto"
import { ApiClient } from "@modules/core/api/client/apiClient"
import dayjs from "dayjs"

export class BoxPlanningApi {
  private baseUrl = "/boxes/slots"

  constructor(private api: ApiClient) {}

  async getSlots(
    startDate: Date | undefined,
    endDate: Date | undefined,
    programId?: string,
  ): Promise<BoxSlotItemEntity[]> {
    if (startDate && endDate) {
      const result = await this.api.get<BoxSlotItemDto[]>(this.baseUrl, {
        params: {
          startTime: dayjs(startDate).toISOString(),
          endTime: dayjs(endDate).toISOString(),
          programId,
        },
      })
      return result.data.map((slotDto) => BoxSlotItemEntity.fromDto(slotDto))
    }
    return []
  }
}
